import { Navigate, Outlet } from 'react-router';
import { TOOLKIT_PATH } from '../config';
import { useAppSelector } from '../store/hooks';
import { selectIsAdmin } from '../store/authSlice';

// A layout route inside ProtectedLayout, so a session exists by the time this runs.
// **UX only**, like `RequireSdlcAccess`: every route the admin pages call needs the
// `admin` scope at the gateway, so this exists so nobody lands on a page whose every
// request is refused, and is not the security boundary.
export const RequireAdmin = () => {
  const isAdmin = useAppSelector(selectIsAdmin);

  if (!isAdmin) {
    return <Navigate to={TOOLKIT_PATH} replace />;
  }

  return <Outlet />;
};
